export {};
//# sourceMappingURL=SensitivityIcon.types.js.map